import axios from "axios";

let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";

let axiosInstance = axios.create({
    baseURL: `${secure}${process.env.VUE_APP_ENDPOINT_SERVICES_BOOKING}`,
    timeout: 10000,
});

const f = (rooms) => {
    let adults = 0;
    rooms.forEach(room => {
        room.adults.forEach(() => {
            adults++;
        });
    });
    return adults;
};
const g = (rooms) => {
    let children = [];
    rooms.forEach(room => {
        room.children.forEach((child) => {
            children.push(child.age);
        });
    });
    return children;
};
const prepareParams = (query) => {
    let params = null;
    if (query) {
        let occupancies = [];
        query.rooms.forEach(room => {
            let occupancy = '';
            room.adults.forEach(adult => {
                occupancy = occupancy.concat(adult.age.toString(), ',')
            });
            room.children.forEach(child => {
                occupancy = occupancy.concat(child.age.toString(), ',')
            });
            occupancies.push(occupancy.replace(/(^\s*,)|(,\s*$)/g, ''));
        });

        params = {
            location_id: query.place_id,
            check_in: query.check_in,
            check_out: query.check_out,
            occupancies: occupancies,
            currency: query.currency,
            language: 'RO'
        };
    }
    return params;
};
const appendValues = (response, query) => {
    response.data.check_in = query.check_in;
    response.data.check_out = query.check_out;
    response.data.currency = query.currency;
    response.data.adults = f(query.rooms);
    response.data.children = g(query.rooms);
    return response.data;
};

/**
 * @param {string} locationId
 * @param {Object} query
 */
export function getHotelsByLocationId(locationId, query) {

    let params = prepareParams(query);

    return axiosInstance.get('/api/search/hotels', {params: params})
        .then(response => appendValues(response, query))
        .catch(error => console.log(error));
}

/**
 * @param {Array<Number>} hotelIds
 */
export function getStaticHotelsByIds(hotelIds) {
    return axiosInstance.get('/api/statics/hotels', { params: { ids: hotelIds }})
        .catch(error => console.log(error));
}

/**
 * @param {number} hotelId
 * @returns {Promise<T>}
 */
export function getHotelById(hotelId) {
    return axiosInstance.get(`/api/statics/hotels/${hotelId}`)
        .catch(error => console.log(error));
}

/**
 * @param {Number} hotelId
 * @param {Object|null} query
 * @returns {Promise}
 */
export function getHotelAvailabilityById(hotelId, query = null) {

    let params = prepareParams(query);

    return axiosInstance.get(`/api/search/hotels/${hotelId}`, {params: params})
        .then(response => appendValues(response, query))
        .catch(error => console.log(error));
}

export default { getHotelById, getHotelAvailabilityById, getHotelsByLocationId, getStaticHotelsByIds };
